

/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Popover, Modal, Upload, Spin, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, PlusOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import './industrialPartner.css';
import UploadModal from './uploadModal';
import PartnerContactFormModal from './partnerContactFormModal';
const { TabPane } = Tabs;
const { TextArea } = Input;
const { confirm } = Modal;
const ClassicEditor = window.ClassicEditor;

const IndustrialPartner = (props) => {

    const imageNum = 1;
    const [form] = Form.useForm();
    const messageRef = useRef();
    const [deleteTipText, setDeleteTipText] = useState("");
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [isDeleteFrame2, setIsDeleteFrame2] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [tablesCount2, setTablesCount2] = useState(0);
    const [current2, setCurrent2] = useState(1);
    const [pageSize2, setPageSize2] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    const [partnerModel, setPartnerModel] = useState({});
    const [isDisabled, setIsDisabled] = useState(true);
    const [partnerContractModel, setPartnerContractModel] = useState({});
    const [partnerContractFormFlag, setPartnerContractFormFlag] = useState('add');
    const [isPartnerContract, setIsPartnerContract] = useState(false);
    const [deptModel, setDeptModel] = useState([]);
    const [progAllList, setProAllList] = useState([]);
    const [progList, setProgList] = useState([]);
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [defaultDate, setDefaultDate] = useState(moment());
    const [childActiveKey, setChildActiveKey] = useState("1");
    const [ckeditor, setCkeditor] = useState(null);

    useEffect(() => {
        search(pageSize, 1, "N");
        searchDept();
        searchProg();
        if (Base.isEmpty(ckeditor)) {
            ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfigWebsite)
                .then(editor => {
                    setCkeditor(editor);
                }).catch(error => { console.log(error) });
        }
    }, []);

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("partner/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                setChildActiveKey("1")
                setIsDisabled(true)
                setGroupMemberTables([])
                search(pageSize, current, "Y");
                ckeditor.setData('');
            }
        }
    }

    const add = () => {
        messageShowHandler();
        setGroupMemberTables([]);
        setPartnerModel({})
        initForm({ activeInd: 'Y' });
        setFlag("add");
        setTabIndex("2");
        setImageFile([])
    }

    const download = () => {
        setIsUpload(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        searchById(model.partnerId)
        setTabIndex("2");
        setFlag("edit");
    }

    const searchDept = () => {
        Base.callBackApi('commonDropDown/searchAllDept').then((data) => {
            if ("SUCCESS" == data.msg) {
                setDeptModel(data?.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const searchProg = () => {
        Base.callBackApi('commonDropDown/searchAllProgramme', {}).then((data) => {
            if ("SUCCESS" == data.msg) {
                let list = (data?.object ?? [])?.filter(item => item.progCode != 'UNCERTAIN')
                setProAllList(list);
                setProgList(list)
            } else {
                errFrameShow("error", data.msg);
            } 
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const update2 = (model, e) => {
        messageShowHandler();
        setPartnerContractFormFlag('edit')
        setPartnerContractModel(model);
        setIsPartnerContract(true);
    }

    const partnerAdd = (param) => {
        messageShowHandler();
        const filteredUsers = groupMemberTables.filter(user => user.activeInd == 'Y');
        if (param == 1) {
            if (filteredUsers.length >= 1) {
                errFrameShow("error", "Only One active contact can be added.");
                return;
            }
            setPartnerContractModel({ partnerId: partnerModel.partnerId, activeInd: "Y" });
        } else {
            setPartnerContractModel({ partnerId: partnerModel.partnerId, activeInd: "N" });
        }
        if (Base.isEmpty(partnerModel.partnerId)) {
            errFrameShow("error", "Please save partner information first.");
            return;
        }
        setPartnerContractFormFlag('add')
        setIsPartnerContract(true);
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            industrialPartnerId: model.industrialPartnerId ?? "",
            industrialPartnerCompanyName: model.industrialPartnerCompanyName ?? "",
            companyLocation: model.companyLocation ?? "",
            companyName: model.companyName ?? "",
            academicPersonSurname: model.academicPersonSurname ?? "",
            academicPersonGivenName: model.academicPersonGivenName ?? "",
            academicPersonDepartment: model.academicPersonDepartment ?? "",
            contactPersonJobTitle: model.contactPersonJobTitle ?? "",
            contactPersonOfficePhone: model.contactPersonOfficePhone ?? "",
            contactPersonMobilePhone: model.contactPersonMobilePhone ?? "",
            companyLogo: model.companyLogo ?? "",
            companySocailMedia: model.companySocailMedia ?? "",
            companyYouTuBe: model.companyYouTuBe ?? "",
            contactEmail: model.contactEmail ?? "",
            THEiContactName: model.THEiContactName ?? "",
            THEiContactPhone: model.THEiContactPhone ?? "",
            activeInd: model.activeInd ?? "",
            LoginAccountName: model.LoginAccountName ?? "",
            loginAccount: model.loginAccount ?? "",
            companyWebsite: model.companyWebsite ?? "",
            inactiveDate: model.inactiveDate ? moment(moment(model.inactiveDate).format(Config.dateFormat5), Config.dateFormat5) : null,
            companyInstagram: model.companyInstagram ?? "",
            companyFacebook: model.companyFacebook ?? "",
            companyWeChat: model.companyWeChat ?? "",
            other: model.other ?? "",
            hkBusinessRegNo: model.hkBusinessRegNo ?? "",
            theiContactName: model.theiContactName ?? "",
            theiDeptId: model.theiDeptId ?? "",
            theiProgId: model.theiProgId ?? "",
        });
        if(model.theiDeptId) {
            let list = progAllList?.filter(item => item.deptId == model.theiDeptId)
            setProgList(list)
        } else {
            setProgList(progAllList)
        }
    }
    const handleChange = (value) => {
        if (value === 'N') {
            form.setFieldValue('inactiveDate', moment());
            setIsDisabled(false)
        } else {
            form.setFieldValue('inactiveDate', null);
            setIsDisabled(true)
        }
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = partnerModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("partner/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteFrameClose2 = (state) => {
        if (state) {
            deleteData2();
        }
        // clearSelect();
        setIsDeleteFrame2(false);
    }

    const deleteData2 = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = partnerContractModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("partnerContact/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchPartnerList(partnerModel, pageSize2, 1, "", "", "Y");
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (model) => {
        messageShowHandler();//清空提示信息
        model.companyProfile = ckeditor.getData();
        if (!model.companyProfile) {
            errFrameShow("error", "Company Description is required.");
            return;
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        if (imageFile && imageFile.length > 0) {
            model.companyLogoModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        let url = "";
        if (flag === "add") {
            url = "partner/insert";
        } else if (flag === "edit") {
            url = "partner/update";
            model.partnerId = partnerModel.partnerId;
            model.lastUpdatedDate = partnerModel.lastUpdatedDate;
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const searchById = (model) => {
        Base.callBackApi("partner/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setFlag("edit");
                let file = [];
                if (model.companyLogo) {
                    file.push({
                        url: Config.partnerImg + model.companyLogo + '?' + Config.sasToken,
                        originUrl: model.companyLogo,
                        imgStatus: "OLD"
                    })
                }
                setImageFile(file);
                if (childActiveKey == "1") {
                    searchPartnerList(model, pageSize2, 1, "", "", "Y");
                } else {
                    searchPartnerList(model, pageSize2, 1, "", "", "N");
                }
                setPartnerModel(model)
                handleChange(model.activeInd)
                ckeditor.setData(model?.companyProfile ?? "");
                initForm(model)
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setGroupMemberTables([]);
        setTabIndex("1");
        ckeditor.setData('');
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setPartnerModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Company Name" + ":" + model.companyName + "")
    }

    const deleteOne2 = (model, e) => {
        e.stopPropagation();
        setPartnerContractModel(model)
        setIsDeleteFrame2(true);
        setDeleteTipText("Industry Partner ID" + ":" + model.partnerContactAcctId + "")
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    const onChange2 = (currentNew, pageSizeNew) => {
        searchPartnerList(partnerModel, pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }
    const onShowSizeChange2 = (currentNew, pageSizeNew) => {
        searchPartnerList(partnerModel, pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadClose = (flag) => {
        if (flag) {
            search(pageSize, 1, "N");
            errFrameShow("success", trans.importSuccess[Config.backLang]);
        }
        setIsUpload(false);
    }

    const closePartnerContactForm = (flag) => {
        if (flag) {
            errFrameShow("success", trans.saveSuccess[Config.backLang]);
            if (childActiveKey == "1") {
                searchPartnerList(partnerModel, pageSize2, 1, "", "", "Y");
            } else {
                searchPartnerList(partnerModel, pageSize2, 1, "", "", "N");
            }

        }
        setIsPartnerContract(false);
    }
    const searchPartnerList = (model, pageSizeNew, currentPageNew, flag, isShowMsg, mainContact) => {
        const partnerContactModel = {};
        partnerContactModel.partnerId = model.partnerId;
        partnerContactModel.pageSize = pageSizeNew;
        // partnerContactModel.mainContact = mainContact
        partnerContactModel.startRow = (currentPageNew - 1) * pageSizeNew;
        partnerContactModel.page = currentPageNew;
        Base.callBackApi("partnerContact/search", partnerContactModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                setPartnerContractModel(data.object ?? []);
                setTablesCount2(data?.object?.total ?? 0);
                setGroupMemberTables(data?.object?.list ?? []);
                setCurrent2(currentPageNew);
                setPageSize2(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject(trans.awaitImg[Config.backLang]);
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject(trans.loseImg[Config.backLang]);
            }
        }
        return Promise.resolve();
    }

    const handleChangeImg = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    const handleRemove = (file) => {
        confirm({
            content: trans.deleteImg[Config.backLang],
            okText: trans.ok[Config.backLang],
            okType: 'danger',
            cancelText: trans.cancel[Config.backLang],
            onOk() {
                let index = imageFile.findIndex(item => item.uid == file.uid);
                let fileList = JSON.parse(JSON.stringify(imageFile));
                fileList.splice(index, 1);
                setImageFile(fileList);
            },
            onCancel() {
            },
        });
        return false;
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>{trans.settingsImg[Config.backLang]}</div>
        </div>
    );

    /*eslint-disable*/
    const columns = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth25',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: 'Company Website',
            dataIndex: 'companyWebsite',
            className: 'tableWidth30',
        },
        {
            title: "Office Address",
            dataIndex: 'companyLocation',
            className: 'tableWidth30',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyLocation') },
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="companyLocation">{text}</div>
            </Popover>

        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 206,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    const groupMemberColumns = [
        {
            title: 'Industry Partner ID',
            dataIndex: 'partnerContactAcctId',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'partnerContactAcctId') },
        },
        {
            title: 'Title',
            dataIndex: 'contactTitle',
            className: 'tableWidth11',
        },
        {
            title: 'Name',
            dataIndex: 'contactName',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactName') },
        },
        {
            title: 'Job Title',
            dataIndex: 'contactJobTitle',
            className: 'tableWidth11',
        },
        {
            title: 'Department',
            dataIndex: 'contactDept',
            className: 'tableWidth14',
        },
        {
            title: 'Email',
            dataIndex: 'contactEmail',
            className: 'tableWidth11',
        },
        {
            title: 'Office Phone',
            dataIndex: 'contactOfficePhone',
            className: 'tableWidth12',
        },
        {
            title: 'Mobile',
            dataIndex: 'contactMobilePhone',
            className: 'tableWidth13',
        },
        {
            title: 'Status',
            dataIndex: 'activeInd',
            className: 'tableWidth6',
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: 'Inactive Date',
            dataIndex: 'inactiveDate',
            className: 'tableWidth9',
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            width: 206,
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update2(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne2(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ]
    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }
    const handleTableChange2 = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns2[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns2[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                searchPartnerList(partnerModel, pageSize2, 1);
            }
        }
    }
    const tableColumns = {
        companyName: "companyName",
        companyLocation: "companyLocation",
        activeInd: "activeInd",
        inactiveDate: "inactiveDate",
    }
    const tableColumns2 = {
        partnerContactAcctId: "partnerContactAcctId",
        contactName: "contactName"
    }

    const downloadTemplate = () => {
        setIsLoad(true);
        setSpinInfo(trans.loading[Config.backLang]);
        fetch(Config.apiDownloadServer + "partnerTemplate/exportTemplate", {
            method: 'POST',
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "PartnerTemplate.xlsx";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const handleDeptChange = (value) => {
        form.setFieldValue('theiProgId', null)
        let list = progAllList?.filter(item => item.deptId == value)
        setProgList(list)
      };

    return (
        <div id="container" className="template industrialPartner">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isDeleteFrame2 ? <PopupFrame close={deleteFrameClose2} deleteTipText={deleteTipText} /> : null}
                    {/* {isDeleteFrame ? <DeleteFrame close={deleteFrameClose} 
                        deleteTipText={deleteTipText}
                        tipText={"Before delete, please make sure the user is not used in Email Template."} 
                        content={"Are you sure to delete?"}/>
                    : null}
                    {isDeleteFrame2 ? <DeleteFrame close={deleteFrameClose2} 
                        deleteTipText={deleteTipText}
                        tipText={"Before delete, please make sure the user is not used in Email Template."} 
                        content={"Are you sure to delete?"}/>
                    : null} */}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle industrialPartnerSerchTitle">{trans.industrialPartnerCompanyName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.companyName || ''}
                                                placeholder={trans.industrialPartnerCompanyName[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('companyName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                <Button className='sysBtn btnBlue' type="primary" onClick={downloadTemplate} hidden={Config.funcInfo.canUpload === "N"} icon={<DownloadOutlined />}>{trans.downloadTemplate[Config.backLang]}</Button>
                                <Button type="primary" className="sysBtn btnBlue" onClick={download} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1200 }}
                                    rowKey="partnerId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.industrialPartner[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow' hidden>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Industrial Partner ID</div>
                                        <div className="sysInput">
                                            <Input type="text" value={partnerModel.partnerId} disabled placeholder={"Industrial Partner ID"} maxLength={50} />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.industrialPartnerCompanyName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyName"
                                                rules={[
                                                    { required: true, message: "Company Name is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.industrialPartnerCompanyName[Config.backLang]} maxLength={50} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Company Website</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyWebsite"
                                            >
                                                <Input type="text" placeholder="Company Website" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput ">Company LinkedIn</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companySocailMedia"
                                            >
                                                <Input type="text" placeholder="Company LinkedIn" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Company YouTube</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyYouTuBe"
                                            >
                                                <Input type="text" placeholder="Company YouTube" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className="sysCol">
                                        <div className="sysParam sysParamInput">Company Instagram</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyInstagram"
                                            >
                                                <Input type="text" placeholder="Company Instagram" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="sysCol">
                                        <div className="sysParam sysParamInput">Company Facebook</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyFacebook"
                                            >
                                                <Input type="text" placeholder="Company Facebook" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className="sysCol">
                                        <div className="sysParam sysParamInput">Company WeChat</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="companyWeChat"
                                            >
                                                <Input type="text" placeholder="Company WeChat" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="sysCol">
                                        <div className="sysParam sysParamInput">Other</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="other"
                                            >
                                                <Input type="text" placeholder="Other" maxLength={200} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol' >
                                        <div className="sysParam sysParamInput mustFill">{trans.companyLocation[Config.backLang]}</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="companyLocation"
                                                rules={[
                                                    { required: true, message: "Office Address is required." },
                                                ]}
                                            >
                                                <TextArea className="textarea" placeholder={trans.companyLocation[Config.backLang]} maxLength={1000} rows={3} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol' >
                                        <div className="sysParam sysParamInput mustFill">Company Description</div>
                                        <div className="sysInputMax">
                                            <div id="editor" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className="sysCol">
                                        <div className="sysParam sysParamInput">Hong Kong Business Registration Number</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="hkBusinessRegNo"
                                                rules={[
                                                    { required: false },
                                                ]}
                                            >
                                                <Input type="text" placeholder="Hong Kong Business Registration Number" maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.img[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Modal title={trans.maxImg[Config.backLang]} visible={previewVisible} footer={null} onCancel={handleCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal>
                                            <Form.Item
                                                name="companyLog"
                                                rules={[
                                                    { validator: (rule, value) => checkImg(value) }
                                                ]}
                                            >
                                                <Upload
                                                    action={Config.uploadTestServer}
                                                    key={"1"}
                                                    accept=".png, .jpg, .jpeg"
                                                    listType="picture-card"
                                                    fileList={imageFile}
                                                    onPreview={handlePreview}
                                                    onRemove={handleRemove}
                                                    onChange={(file) => handleChangeImg(file)}>
                                                    {imageFile.length >= imageNum ? null : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.status[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' onChange={handleChange}>
                                                    <Option value=''></Option>
                                                    {context.activeStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {isDisabled ?
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Inactive Date</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                >
                                                    <DatePicker placeholder="Inactive Date" disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        :
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Inactive Date</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                    rules={[
                                                        { required: true, message: "Inactive Date is required." },
                                                    ]}
                                                >
                                                    <DatePicker placeholder="Inactive Date"
                                                        value={defaultDate}
                                                        disabledDate={disabledDate}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol' >
                                        <div className="sysParam sysParamInput">Last Job Post Date</div>
                                        <div className="sysInput">
                                            <Input type="text" disabled maxLength={200} value={partnerModel.dateOfLastJobPost ? moment(partnerModel.dateOfLastJobPost).format(Config.dateFormatEn) : ''} defaultValue={partnerModel.dateOfLastJobPost ? moment(partnerModel.dateOfLastJobPost).format(Config.dateFormatEn) : ''} />
                                        </div>
                                    </div>
                                    <div className='sysCol' >
                                        <div className="sysParam sysParamInput">Number of Job Post</div>
                                        <div className="sysInput" >
                                            <Input className="textarea" disabled maxLength={1000} rows={3} value={partnerModel.totalNumberOfJobPosts === 0 ? '' : partnerModel.totalNumberOfJobPosts} />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">THEi Requestor Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="theiContactName"
                                                rules={[
                                                    { required: true, message: "THEi Requestor Name is required." },
                                                ]}
                                            >
                                                <Input type="text" placeholder="THEi Requestor Name" maxLength={40} />
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">THEi Requestor Department</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="theiDeptId"
                                                rules={[
                                                    { required: true, message: "THEi Requestor Department is required." },
                                                ]}
                                            >
                                                <Select className='sysSelect' onChange={handleDeptChange}>
                                                    <Option value=''></Option>
                                                    {deptModel?.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + "-" + item.deptDisplayName}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">THEi Requestor Programme</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="theiProgId"
                                                rules={[
                                                    { required: true, message: "THEi Requestor Programme is required." },
                                                ]}
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {progList?.map((item) => <Option key={item.progId} value={item.progId}>{item.progTitle}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">Partner Contact</div>
                                </div>
                                <div className="sysBodyRow">
                                    <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={() => partnerAdd(1)} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>
                                </div>
                                <div className="sysTable" id="tableTwo">
                                    <Table
                                        scroll={{ x: 2750 }}
                                        rowKey="partnerId" //Key值
                                        columns={groupMemberColumns} //列名
                                        dataSource={groupMemberTables} //数据
                                        pagination={{  //分页
                                            showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                            onChange: onChange2,                  //上页下页或者跳页方法
                                            onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                            total: tablesCount2,        //总共多少条数据
                                            current: current2,       //当前页
                                            pageSize: pageSize2,  //每页显示多少条数据
                                            defaultCurrent: 1,          //默认当前页为1
                                            size: "small"
                                        }}
                                        onChange={handleTableChange2}
                                    />
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
            {isPartnerContract && <PartnerContactFormModal onClose={closePartnerContactForm} partnerModel={partnerModel} partnerContractModel={partnerContractModel} partnerContractFormFlag={partnerContractFormFlag} />}
        </div>
    )

}

export default IndustrialPartner;